module.exports = __webpack_public_path__ + "static/media/opl1.png.da56824d.jpg";